module.exports = __webpack_public_path__ + "img/NS-J-6.b5665b27.svg";